/** 下单美元价：规整 JSON 浮点尾差 */
export function normalizeOrderPrice(price) {
  const n = Number(price);
  if (!Number.isFinite(n) || n <= 0) return 0;
  return Math.round(n * 100000) / 100000;
}

/** 下单数量：最多 6 位小数（USDC / 链上精度；截断，与后台一致） */
export function normalizeOrderQuantity(quantity) {
  const n = Number(quantity);
  if (!Number.isFinite(n) || n <= 0) return 0;
  return Math.floor(n * 1e6 + 1e-12) / 1e6;
}

/** 买单所需平台 USDC（含轻微缓冲） */
export function estimateBuyOrderCostUsd(requestBody) {
  const price = Number(requestBody?.price ?? 0);
  const quantity = Number(requestBody?.quantity ?? 0);
  if (!Number.isFinite(price) || !Number.isFinite(quantity) || price <= 0 || quantity <= 0) {
    return 0;
  }
  return normalizeOrderPrice(price * quantity);
}
